import { COMPLEXITY_TIERS } from "@/data/content";

const CONF = {
  price: {
    label: "Price",
    glyph: "$",
    on: "text-steel-brass",
    names: ["No added fee", "Lowest", "Low", "Moderate", "High", "Highest"],
  },
  complexity: {
    label: "Complexity",
    glyph: "!",
    on: "text-amber-400",
    names: ["", ...COMPLEXITY_TIERS.map((t) => t.name)],
  },
};

// 1-5 glyph meter used for both price and complexity so the two read at a glance.
export const TierMeter = ({ kind, value, showLabel = true, testid }) => {
  const conf = CONF[kind];
  const v = Math.max(0, Math.min(5, Number(value) || 0));
  const pct = Math.round((v / 5) * 100);
  const title = `${conf.label}: ${conf.names[v] || `${v} of 5`} — ${v}/5 (${pct}%)`;

  if (kind === "price" && v === 0) {
    return (
      <span
        data-testid={testid}
        title="No added fee — included in the base return"
        className="inline-flex items-center gap-1.5 font-mono text-[9px] uppercase tracking-[0.18em] text-emerald-400"
      >
        Price · Included
      </span>
    );
  }

  return (
    <span data-testid={testid} title={title} className="inline-flex items-center gap-1.5">
      {showLabel && (
        <span className="font-mono text-[9px] uppercase tracking-[0.18em] text-steel-muted">{conf.label}</span>
      )}
      <span className="font-mono text-[11px] font-bold leading-none tracking-tight">
        {[1, 2, 3, 4, 5].map((n) => (
          <span key={n} className={n <= v ? conf.on : "text-steel-border"}>
            {conf.glyph}
          </span>
        ))}
      </span>
    </span>
  );
};

export default TierMeter;
